import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { connect } from 'react-redux';
import Config from '../../../../../Config';
import LocalLoader from '../../../../Shared/LocalLoader/LocalLoader';
import { buildUrlAndOpenWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';

import fullSpecificationIcon from '../../icons/fullSpecificationIcon.svg';
import download from '../../icons/download.svg';

function EquipmentMine({type, mesError, productName, firstName, epiData, moreDetails, openInstallationGuide, listEquipmentsMine, hebrewTranslation, isLoading }) {

    const clickButton = () => buildUrlAndOpenWindow(epiData.linkButton);
    
    let currentView = null;

    if(isLoading) {
        type = 'loading' 
    };

    if(mesError != 0){
        type = 'errorBackend'
    };

    switch (type) {
        case 'noInformationBack':
            currentView = <NoDataMessage firstName={firstName} clickButton={clickButton} hebrewTranslation={hebrewTranslation}/> 
            break;
        case 'noInformationEpi':
            currentView =  <NoEquipmentMessage firstName={firstName} clickButton={clickButton} productName={productName} /> 
            break;
        case 'displayInformation':
            currentView =   <EquipmentList listEquipmentsMine={listEquipmentsMine} moreDetails={moreDetails} openInstallationGuide={openInstallationGuide} firstName={firstName} /> 
            break;
        case 'errorBackend':
            currentView =   <MesError firstName={firstName} clickButton={clickButton} />
            break;
        case 'noEquipment':
            currentView =   <NoEquipment firstName={firstName} productName={productName}/>
            break;
        case 'loading':
            currentView =  <LocalLoader />
            break;
        default:
            break;
    };
   
    return (
        <div className={`header-date-prodacts ${type === 'loading' ? 'message-error' : ''}`}>
            {currentView}
        </div>
    );
}

const MessageBox = ({ firstName, content, clickButton, textBtn }) => (
    <div className="message">
        <div className='title'>היי <span>{firstName}</span>,</div>
        <div className='content'>{content}</div>
        {textBtn && 
            <BtnSubmit
            isBusiness={false}
            text={textBtn}
            onclick={clickButton}
            formid='redirection-page'
            isDisplayArrows={false}
            isDisplayWhatsAppIcon={false}
            />
        } 
    </div>
);

const NoDataMessage = ({ firstName, clickButton, hebrewTranslation, textBtn }) => (
    <MessageBox 
        firstName={firstName} 
        content={hebrewTranslation === 'אינטרנט' 
            ? "עדיין אין לך שירות אינטרנט אצלנו."
            : `עדיין אין לך שירות ${window.Config.brand_Name_HE} TV.`
        }
        clickButton={clickButton}
        textBtn= {'תצרפו אותי'}
    />
);

const NoEquipment = ({ firstName, productName }) => (
    <MessageBox
        firstName={firstName} 
        content={
            <>
              נראה שאין לך {productName}
            , תמיד אפשר להזמין אצל נציג במספר  <span style={{ direction: 'ltr', display: 'inline-block' }}> {window.Config.technicalSupportPhone} </span>
            </>
        }
          
    />
);


const NoEquipmentMessage = ({ firstName, clickButton, productName }) => (
    <MessageBox 
        firstName={firstName}
        content={`אנחנו לא מזהים את סוג ${productName} שיש לך.`}
        clickButton={clickButton}
    />
);

const MesError = ({ firstName, clickButton }) => (
    <MessageBox 
        firstName={firstName} 
        content="מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת."
        clickButton={clickButton}
    />
);

const EquipmentList = ({ listEquipmentsMine, moreDetails, openInstallationGuide, firstName }) => (
    <>
        <div className="title-prodacts">
            <span>{`${firstName} `}</span>, זה הציוד שלך
        </div>
        <div className={`${listEquipmentsMine.length == 1 ? 'wrapper-product-one' : 'wrapper-products'}`} >
            {listEquipmentsMine?.map((item, i) => (
                <React.Fragment key={i}>
                    <div className="wrapper-prodact">
                        {item.imageProduct?.value?.url && (
                            <Image src={Config.epiBaseUrl + item.imageProduct?.value?.url} alt="image-prodact" className='image-prodact' />
                        )}
                        <div>
                            <div className="title">דגם :<span> {item.nameModelProdact.value && item.nameModelProdact.value.trim() !== '' ? item.nameModelProdact.value : item.name }</span></div>
                            <div className="wrapper-links">
                                <button className="link-wrapper" onClick={() => moreDetails(item)}>
                                    <Image src={fullSpecificationIcon} alt="icon" />
                                    <div>מפרט מלא</div>
                                </button>
                                { item.installationGuide?.value &&  <button className="link-wrapper" onClick={() => openInstallationGuide(item)} style={{}}>
                                    <Image src={download} alt="icon" />
                                    <div>מדריך התקנה</div> 
                                </button>
                                }
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            ))}
        </div>
    </>
);

const mapStateToProps = (state) => ({
    loginData: state?.authentication?.loginData,
    firstName: state.equipmentListPage.firstName,
    epiData: state.equipmentListPage.epiData,
    mesError: state.equipmentListPage.mesError,

});

export default connect(mapStateToProps)(EquipmentMine);
